/* eslint-disable max-len */
import { isEqual } from "lodash";
import { useSelector } from "react-redux";
import { useRequest } from "redux-query-react";
import { getMarketRaw } from "api/admin/src";
/**
 * Use this selector to get a reference to a single GetSingleMarketResponse matching the id
 * @param id Id of the GetSingleMarketResponse
 * @returns The GetSingleMarketResponse object
 */
export const useMarketByIdSelector = (id) => {
    let key = "";
    if (id) {
        key = `${key}${id}`;
    }
    return useSelector((state) => state.entities.Market[key], isEqual);
};
/**
 * Request hook for a single GetSingleMarketResponse. Beware, this should not be called without a valid id ***WIP***
 * @param requestParameters the id for the market request
 * @param customQueryConfig configurations for the request and meta information
 * @returns an array containing the data, query state, and a call for refresh
 * (note : refresh shouldn't be necessary, update to the state should be handle by mutators)
 */
export const useGetMarket = (requestParameters, customQueryConfig) => {
    const [querystate, forceRefresh] = useRequest(getMarketRaw(requestParameters, customQueryConfig));
    return [
        useMarketByIdSelector(requestParameters.id),
        querystate,
        forceRefresh
    ];
};
